// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1a-JR","modalForm":"UpgradeEpcsModal_modalForm__1SEt8","modalFooter":"UpgradeEpcsModal_modalFooter__3pOO7"};